import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { AddToCartContext } from './AddToCartContext';
import { withTranslation } from 'react-i18next';

const CartDropdownFooter = ({ onClick, t }) => {
    const { colors } = useContext(AddToCartContext);

    return (
        <Button
            hoverStyleChange={true}
            onClick={onClick}
            primaryColor={colors && colors.buyNowPrimaryColor}
            secondaryColor={colors && colors.buyNowSecondaryColor}
            className="product-button flex-center obsessvr-regularFont full-width pointer"
            style={{ padding: '0', margin: '1em auto 0.7em', width: '280px', height: '52px' }}
            primaryBorderColor={colors && colors.buyNowBorderColor}
            secondaryBorderColor={colors && colors.buyNowBorderColor}
            insetBorder={true}
            padded={false}
        >
            <p className='obsessvr-regularFont' style={{ fontFamily: "'MessinaSans-SemiBold'", fontSize: '12px', textTransform: 'uppercase' }}>
                {t('wishlistCartDropdown3')}
            </p>
        </Button>
    )
}

export default withTranslation()(CartDropdownFooter);
